/**
 * Check if we're currently in the second bite flow
 */
export function isSecondBiteFlow(): boolean {
    const currentRoute = window.route().current();
    return currentRoute?.startsWith("second-bite") ?? false;
}
